<rb-loading-spinner *ngIf="dataLoading" class="spinner"></rb-loading-spinner>
<div class="row ms-0 me-0" *ngIf="errorMessage && !dataLoading">
    <rb-callout type="warning">
        No data for "Temperature comfort zone usage" chart.
    </rb-callout>
</div>
<div id="temperature-comfort-zone-chart"></div>
<div class="p-2" *ngIf="!dataLoading && !errorMessage">
    <div class="shaded-container ">
        Distribution of total operation hours spent in different temperature regimes.
        Green colors correspond to the comfort temperature zone while red and blue represent unfavorable edge conditions.
    </div>
</div>